import { isApiError } from '@/utils/error'
import { showError, showSuccess } from '@/utils/toast'

const handleMutationError = (error: unknown) => {
  if (isApiError(error)) {
    showError(error.message)
    return
  }
}

export const getMutationOptions = ({
  successMessage,
  onSuccess,
}: {
  successMessage?: string
  onSuccess?: () => void
}) => ({
  onSuccess: () => {
    showSuccess(successMessage ?? 'Success')
    onSuccess?.()
  },
  onError: handleMutationError,
})
